import SwitchToPrivate from './SwitchToPrivate'

export default SwitchToPrivate
